import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MailIcon from "../../MainIcons/MailIcon";
import "./userDetails.css";
import checkcircle from "../../../image/check-circle.svg";
import {
  DeleteRole,
  editUserDetails,
  editUserRole,
  fetchrolendretrole,
  getCurrentSession,
  getkeycloakuserdata,
  Deleteuser,
  getGroupsUserId,
} from "../Helpingfiles/KeycloakHelpmethods";
import { useNavigate, useParams } from "react-router";
import { first } from "lodash";

const UserDetail = (props) => {
  const [open, setOpen] = useState(false);
  const params = useParams();

  const [userDataJson, setUserDataJson] = useState(null);
  const [currentRole, setCurrentRole] = useState(null);
  const [currentSession, setCurrentSession] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [emailId, setEmailId] = useState(null);
  const[role,setRole]=useState(null);
  const[majorRole,setMajorRole]=useState(null);
  const [clientRoleId, setclientRoleId] = useState(null);
  const [clerkRoleId, setclerkRoleId] = useState(null);
  const [approverRoleID, setapproverRoleID] = useState(null);
  const [designerRoleID, setDesignerRoleID] = useState(null);
  const Navigate = useNavigate();
 

  useEffect(()=>
  {
   const fetchroles=async ()=>
   {
    const roleIDdata=await getGroupsUserId();
    setMajorRole(roleIDdata[1].subGroups)
   
   }
   fetchroles();
  },[])




  useEffect(() => {
    const testfun = async () => {
      let data = await getkeycloakuserdata(params._id);

      setUserDataJson(data);

      let roleData = await fetchrolendretrole(params._id);
      setCurrentRole(roleData);
      setRole(roleData);

      let sessionData = await getCurrentSession(params._id);
      setCurrentSession(sessionData);
    };

    testfun();
  }, []);

  useEffect(()=>
  {
    if(majorRole)
    {
      console.log(majorRole)
      majorRole.forEach(element => {
        console.log(element)
        if(element.name=="formsflow-designer")
        {
          setDesignerRoleID(element.id)
        }
        if(element.name=="formsflow-client")
        {
          setclientRoleId(element.id)
         
        }
        if(element.name=="formsflow-reviewer")
        {
          element.subGroups.forEach(elementsec=>{
  
            if(elementsec.name=="approver")
        {
          setapproverRoleID(elementsec.id)
        }
        if(elementsec.name=="clerk")
        {
          setclerkRoleId(elementsec.id)
        }
          })
        }
      })
    }
    
  })

  const yogi = "yogi";

  return (
    <div className="userdetailsPage">
      <div className="EvidenceTaskNavbar">
        <div></div>
     
        <div className="UserdetailsNavbar1">
          <MailIcon state={props.state} />
        </div>
      </div>
      <div className="UserdetailsNavbar2">
        <span>
          <Button
            className="NameOfTheUser "
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {JSON.parse(
              localStorage.getItem("UserDetails")
            ).preferred_username.slice(0, 1)}
          </Button>
        </span>
        <span className="FullName">John Doe</span>
      </div>
      <div className="UserdetailsNavbar3">
        <h1 className="HeadNav3">User Details</h1>
      </div>
      <div className="UserdetailsMainPage">
        <h2 className="horizentalLine">
          <span className="userdetailtext">user Details</span>
        </h2>
        <div className="USerInformation">
          <div className="ListOfRoles">
            <div>
              <label className="label">Username:</label>
              <span className="UserData">
                {userDataJson && userDataJson.username}
              </span>
            </div>
            <div>
              <label className="label">Email:</label>
              <span className="UserData">
                {userDataJson && userDataJson.email}
              </span>
            </div>
            <div>
              <label className="label">Role:</label>
              <span className="UserData">{currentRole && currentRole}</span>
            </div>
            <div>
              <label className="label">Created:</label>
              <span className="UserData">
                {userDataJson &&
                  new Date(userDataJson.createdTimestamp).toLocaleString()}
              </span>
            </div>
            <div>
              <label className="label">Last Login:</label>
              <span className="UserData dateoflogin">
                {currentSession && currentSession.length > 0 ? (
                  new Date(currentSession[0].lastAccess).toLocaleString()
                ) : (
                  <>not found!!!</>
                )}
              </span>
            </div>
          </div>
          <div className="ListOfRoles">
            <div>
              <label className="label">Status:</label>
              <span className="UserData activationStatus">Activated</span>
            </div>
            <div>
              <label className="label">Account Owner:</label>
              <img src={checkcircle} alt="Check Circle" />
            </div>
            <div>
              <button
                onClick={() => Deleteuser(userDataJson.id).then((data)=>
                {
                 if(data==true)
                 {
                  Navigate("/settings")
                 }
                 else{
                  alert("something went wrong, please try again!!!")
                 }
                })}
                className=" btn btn-danger"
              >
                Delete User
              </button>
            </div>
          </div>
        </div>
        <div className="HorizentalLine2">
          <h2 className="horizentalLine">
            <span className="userdetailtext">Edit name</span>
          </h2>
          <h2 className="horizentalLine">
            <span className="userdetailtext">Edit role</span>
          </h2>
        </div>
        <div className="SemiFormFilling">
          <div className="column-6">
            <form>
              <div className="Labels">
                <lable className="FirstNameLabel">
                  <span>*</span>First name
                </lable>
                <input
                  type="text"
                  onChange={(e) => {
                    e.preventDefault();
                    setFirstName(e.target.value);
                  }}
                  value={firstName}
                  className="UserFirstname"
                  placeholder="Enter your first name"
                />
              </div>
              <div className="Labels">
                <lable className="FirstNameLabel">
                  <span>*</span>Last name
                </lable>
                <input
                  type="text"
                  onChange={(e) => {
                    e.preventDefault();
                    setLastName(e.target.value);
                  }}
                  value={lastName}
                  className="UserFirstname"
                  placeholder="Enter your last name"
                />
              </div>
              <div className="Labels">
                <lable className="FirstNameLabel">
                  <span>*</span>Email
                </lable>
                <input
                  type="text"
                  onChange={(e) => {
                    e.preventDefault();
                    setEmailId(e.target.value);
                  }}
                  value={emailId}
                  className="UserFirstname"
                  placeholder="Enter your last name"
                />
              </div>

              <div className="UserSubmitButton">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    editUserDetails(
                      userDataJson.id,
                      userDataJson.createdTimestamp,
                      userDataJson.username,
                      firstName,
                      lastName,
                      emailId
                    );
                  }}
                  className="UserSubmit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>

          {/* <div className='Labels'>
          <labe className="FirstNameLabel"><span>*</span>Role</labe>
          <select  type="select" className='UserFirstname' placeholder='Admin'>
            <option>Admin</option>
            <option>Reviewer</option>
            <option>Approver</option>
          </select>
          </div> */}
          <div className="column-6">
            <div className="Labels">
              <FormControl>
                <InputLabel id="demo-simple-select-label">
                  Change Role
                </InputLabel>
                <Select
                  className="UserFirstname"
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  open={open}
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                  }}
                  onClose={() => setOpen(false)}
                  onOpen={() => setOpen(true)}
                >
                  <MenuItem className="UserFirstname" value="Client">
                    Client
                  </MenuItem>
                  <MenuItem className="UserFirstname" value="Clerk">
                    Clerk
                  </MenuItem>
                  <MenuItem className="UserFirstname" value="Approver">
                    Approver
                  </MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="UserSubmitButton2">
              <button
                onClick={async (e) => {
                  e.preventDefault();
                  if (currentRole == "Client") {
                    await DeleteRole(userDataJson.id, clientRoleId);
                  }
                  if (currentRole == "Clerk") {
                    await DeleteRole(userDataJson.id, clerkRoleId);
                  }
                  if (currentRole == "Approver") {
                    await DeleteRole(userDataJson.id, approverRoleID);
                  }
                  if (role == "Client") {
                    await editUserRole(userDataJson.id, clientRoleId);
                  }
                  if (role == "Clerk") {
                    await editUserRole(userDataJson.id, clerkRoleId);
                  }
                  if (role == "Approver") {
                    await editUserRole(userDataJson.id, approverRoleID);
                  }
                }}
                className="UserSubmit"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
